import dayjs from 'dayjs'

import LineChart from 'components/LineChart'
import { humanizeLargeNumber } from 'utils'

import EmptyStateLive from '../EmptyStateLiveGraphs'

function SelectedGraph({ live, selectedGraph }) {
  function getGraphOptions({ categories }) {
    return {
      xaxis: {
        categories,
      },
      yaxis: {
        min: 0,
        max: max => (Math.max(max) >= 10 ? max : 10),
        labels: {
          formatter: v => humanizeLargeNumber(v, 1),
        },
      },
      legend: {
        show: false,
      },
    }
  }

  function getGraphProps({ performanceKey }) {
    if (!performanceKey) {
      return {}
    }

    const livePerformance = live?.performance ?? []
    const validPerformance = livePerformance.filter(performance => typeof performance?.[performanceKey] === 'number')
    const data = validPerformance.map(performance => performance?.[performanceKey])
    const series = [{ data, name: selectedGraph.label }]
    const categories = validPerformance.map(performance =>
      dayjs.duration(performance?.time, 'seconds').format('HH:mm:ss')
    )
    const options = getGraphOptions({ categories })

    return {
      series,
      options,
    }
  }

  const graphProps = getGraphProps({ performanceKey: selectedGraph?.key })
  const isEmpty = graphProps?.series?.[0]?.data?.length <= 0

  if (isEmpty) {
    return <EmptyStateLive live={live} />
  }

  return <LineChart width="100%" height={281} {...graphProps} />
}

export default SelectedGraph
